// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3an0M","content":"LoadingAlert_content__2wXc2"};